import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/reducers/userReducer';
import { useLoader } from '../useLoader';
import { getAllSubscriptionPlans } from '../../services/subsriptionService';

export const useFetchAllSubscriptionPlan = () => {
  const [allPlans, setAllPlans] = useState([]);

  const user = useSelector(selectUser);
  const { showLoading } = useLoader();

  const fetchAllPlans = async () => {
    try {
      showLoading(true);
      const res = await getAllSubscriptionPlans({
        email: user?.data?.user?.user_id || '',
      });
      setAllPlans(res.data.data);
      showLoading(false);
    } catch (error) {
      showLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPlans();
  }, []);

  return { allPlans };
};
